import React from 'react'

function ManOrgEst() {
  return (
    <div></div>
  )
}

export default ManOrgEst